export default {"src":"/_next/static/media/mailbox.8486b881.svg","height":448,"width":500};